import { fixBody } from "./fix-body";

export function addOffcanvasChangeListener() {
	const offcanvasMenu = document.querySelector("#off-canvas-hamburger");
	if (offcanvasMenu) {
		offcanvasMenu.addEventListener("change", (event) => fixBody(event.target.checked));
	}
}
